import { Component } from '@theme/component';

class CountrySelect extends Component {
  connectedCallback() {
    super.connectedCallback();
    const select = this.querySelector('select');
    const sizer = this.querySelector('[data-country-sizer]');
    if (!select || !sizer) return;

    select.addEventListener('change', () => {
      sizer.textContent = select.selectedOptions[0]?.textContent.trim() ?? '';
    });
  }
}

if (!customElements.get('country-select')) customElements.define('country-select', CountrySelect);
